import { render } from "./myRequestCard.vue?vue&type=template&id=3f2ba61a&scoped=true"
import script from "./myRequestCard.vue?vue&type=script&lang=js"
export * from "./myRequestCard.vue?vue&type=script&lang=js"

import "./myRequestCard.vue?vue&type=style&index=0&id=3f2ba61a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f2ba61a"]])

export default __exports__